import apiService from "./../../../../server";
import { ROLES, UPLOAD_IMG, USER, USERS, USERSDATA } from "../api";

export function fetchAllUsers(page,size) {
    return apiService.get(USERS,{params:{"page":page, "size":size}});
}
export function fetchAllUsersData() {
    return apiService.get(USERSDATA);
}
export function saveUser(user) {
    return apiService.post(USER,user);
}
export function updateUser(user) {
    return apiService.put(USER,user);
}
export function fetchAllRoles(page,size) {
    return apiService.get(ROLES,{params:{"page":page, "size":size}});
}
export function uploadUserImg(user) {
    return apiService.post(UPLOAD_IMG,user,{headers:{
        'Content-Type': 'multipart/form-data',
    }});
}
